// JavaScript Document
// Version: 2.1.0

var productCodeRules = minerva_configurator_vars.product_code_rules;



jQuery(document).ready(function($) {
    /**
	 * Gestisce il login dell'utente.
	 *
	 * @since 1.0.0
	 */
	$('.btnLogin').click(function() {
		showLoginModal();
	});

	$('#login-modal').on('shown.bs.modal', function(e) {
		$('#username').focus();
	});

	$('#login-modal').on('hidden.bs.modal', function(e) {
		var that = $(this);

		$('.status', that).html('');
		$('#username', that).val('');
		$('#password', that).val('');
	});



	/**
	 * Gestisce il submit della form di login.
	 *
	 * @since 1.0.0
	 */
	$('#login-form').on('submit', function(event) {
		event.preventDefault();

		var validationResult = customValidation($('#login-form'));

		if ( validationResult ) {
			var loginData = {
				name: $('#login-form #username').val(),
				pass: $('#login-form #password').val()
			};

			displayLoading(true, 'login');

			login(loginData,
                function(userId) {
                    $('#login-modal').modal('toggle');
                    displayLoading(false, null);
					updateUI(userId);
					showSaveModal();
                },
                function(error) {
					displayLoading(false, null);
                    console.log(error);

					var response = error.responseJSON;

					if ( is_defined(response) ) {
						var message = response.message;

						if ( message == 'Sorry, unrecognized username or password.' ) {
							$('#login-form .status').html('<p>' + minerva_drupal_vars.wrong_login + '</p>');
						} else if ( message == 'This route can only be accessed by anonymous users.' ) {
							// do nothing.
						} else {
							showErrorMessage(error, $('#response-modal'));
						}
					}
                });
		}
	});



	/**
	 * Gestisce la modal-popup per il salvataggio della configurazione.
	 *
	 * @since 1.0.0
	 */
	$('.btnSave').click(function() {
		showSaveModal();
	});

	$('#save-modal').on('shown.bs.modal', function(e) {
		$('#cfgname').focus();
	});

	$('#save-modal').on('hidden.bs.modal', function (e) {
		var that = $(this);

		$('.status', that).html('');
		$('#cfgname', that).val('');
	});



	/**
	 * Gestisce il submit della form per il salvataggio della configurazione.
	 *
	 * @since 1.0.0
	 */
	$('#save-form').on('submit', function(event) {
		event.preventDefault();

		var validationResult = customValidation($('#save-form'));

		if ( validationResult ) {
			displayLoading(true, 'save');

			saveConfiguration(
                function(nodeId) {
                    $('#save-modal').modal('toggle');
					displayLoading(false, null);

					 if ( is_defined(Cookies.get('nodeId')) ) {
                        updateCookie('nodeId', nodeId);
					} else {
                        createCookie('nodeId', nodeId, 'session');
					}

                    $('#saved-configurations-container').fadeIn();
					doubleClick();
                },
                function(error) {
					displayLoading(false, null);
					showSaveModal(false);
                    console.log(error);

					var response = error.responseJSON;

					if ( is_defined(response) ) {
						if ( response == 'Access denied for user anonymous' ) {
							$('#save-form .status').html('<p>' + minerva_drupal_vars.wrong_save + '</p>');
						} else {
							showErrorMessage(error, $('#response-modal'));
						}
					} else {
						showErrorMessage(error, $('#response-modal'));
					}
                },
				'');
		}
	});



	/**
	 * Gestisce il logout dell'utente.
	 *
	 * @since 1.0.0
	 */
	$('.btnLogout').click(function() {
		displayLoading(true, 'logout');

		logout(
			function() {
				displayLoading(false, null);
				updateUI(false);
				$('#saved-configurations-container').fadeOut();
			},
			function(error) {
				displayLoading(false, null);
				showErrorMessage(error, $('#response-modal'));
				console.log(error);
			});
	});



	/**
	 * Crea l'immagine della configurazione per il download.
	 * A seconda dell'attributo del pulsante le immagini potranno essere in alta o in bassa risoluzione.
	 *
	 * @since 1.0.0
	 */
	$('.btnDownloadPreview').on('click', function() {
		var that   = $(this);
		var res    = that.data('res');
		var resize = that.data('resize') || 1;

		displayLoading(true, 'download');
		downloadPreviewImage(res, resize);
	});



	/**
	 * Gestisce il download dell'anteprima.
	 *
	 * @since 1.0.0
	 */
    $('#download-modal img').click(function(e) {
        download($('#download-modal img').attr('src'), $('#download-modal img').attr('alt') + '.png', 'image/png');
        $('#download-modal').modal('hide');
    });

	$('#download-modal .btnDownload').click(function(e) {
		download($('#download-modal img').attr('src'), $('#download-modal img').attr('alt') + '.png', 'image/png');
	});



	/**
	 * Alla chiusura della modal-popup:
	 *   - elimina il canvas dell'anteprima della penna
	 *   - svuota gli attributi del tag "img" contenente l'anteprima della penna
	 *
	 * @since 1.0.0
	 */
	$('#download-modal').on('hidden.bs.modal', function (e) {
		$('#preview-canvas-container').html('<canvas id="preview-canvas"></canvas>');

		// @since 2.0.1
		$('#download-modal .modal-body img').attr('src', '').attr('alt', '');
	});



	/**
	 * Gestisce la richiesta di informazioni.
	 * Se l'utente non è loggato:
	 *    - effettuo il login "anonimo"
	 *    - salvo la configurazione
	 *    - effettuo il logout dall'utente anonimo
	 *    - effettuo il redirect al sito ed alla form
	 *
	 * Il salvataggio della configurazione è necessario perché la richiesta viene inviata con riferimento alla configurazione salvata.
	 *
	 * @since 1.0.0
	 */
	$('.btnSupport').on('click', function() {
		displayLoading(true, 'init');

		var model        = $('.selected-model .model').text().trim();
		var mod          = ( '' != model ) ? 'mod=' + model.toLowerCase() + '&' : '';
		var userId       = null;
		var languageCode = Cookies.get('wp-wpml_current_language');
		var dealer       = is_defined(Cookies.get('dealer')) ? JSON.parse(Cookies.get('dealer')) : false;
		var endpoint     = is_defined(Cookies.get('dealer')) ? minerva_drupal_vars.endpoints.support_dealer : minerva_drupal_vars.endpoints.support;

		if ( is_defined(Cookies.get('instance')) ) {
			var cookieValue = JSON.parse(Cookies.get('instance'));

			userId          = cookieValue.userId ? cookieValue.userId : null;
		}

		if ( userId ) {
			displayLoading(true, 'save');

			saveConfiguration(
				function(nodeId) {
					endpoint = endpoint.replace('{nid}', nodeId);

					if ( userId == minerva_drupal_vars.anonymous_user.uid ) {
						logout(
							function() {
								displayLoading(true, 'redirect');

								_log(
									{
										cfgNodeId: nodeId,
										dealer: dealer,
										redirectUrl: minerva_drupal_vars.host + '/' + languageCode + endpoint
									},
									function() {
										location.href = minerva_drupal_vars.host + '/' + languageCode + endpoint;
									});

								// location.href = minerva_drupal_vars.host + '/' + languageCode + endpoint;
							},
							function(error) {
								displayLoading(false, null);
								showErrorMessage(error, $('#response-modal'));
								console.log(error);
							});
					} else {
						displayLoading(true, 'redirect');

						_log(
							{
								cfgNodeId: nodeId,
								dealer: dealer,
								redirectUrl: minerva_drupal_vars.host + '/' + languageCode + endpoint
							},
							function() {
								location.href = minerva_drupal_vars.host + '/' + languageCode + endpoint;
							});

						// location.href = minerva_drupal_vars.host + '/' + languageCode + endpoint;
					}
				},
				function(error) {
					displayLoading(false, null);
					showErrorMessage(error, $('#response-modal'));
					console.log(error);
				},
				'');
		} else {
			var loginData = {
				name: minerva_drupal_vars.anonymous_user.name,
				pass: minerva_drupal_vars.anonymous_user.pass
			};

			login(loginData,
				function() {
					displayLoading(true, 'save');

					saveConfiguration(
						function(nodeId) {
							endpoint = endpoint.replace('{nid}', nodeId);

							logout(
								function() {
									displayLoading(true, 'redirect');

									_log(
										{
											cfgNodeId: nodeId,
											dealer: dealer,
											redirectUrl: minerva_drupal_vars.host + '/' + languageCode + endpoint
										},
										function() {
											location.href = minerva_drupal_vars.host + '/' + languageCode + endpoint;
										});

									// location.href = minerva_drupal_vars.host + '/' + languageCode + endpoint;
								},
								function(error) {
									displayLoading(false, null);
									showErrorMessage(error, $('#response-modal'));
									console.log(error);
								});
						},
						function(error) {
							displayLoading(false, null);
							showErrorMessage(error, $('#response-modal'));
							console.log(error);
						},
						'anonymous');
				},
				function(error) {
					displayLoading(false, null);
					showErrorMessage(error, $('#response-modal'));
					console.log(error);
				});
		}
	});




});



/**
 * Aggiorna la pagina con i dati riassuntivi della configurazione della penna.
 *
 * @since 1.0.0
 */
function updateConfigurationRecap() {
	var ctx           = jQuery('#pills-recap');
	var moq           = 0;
	var componentsCtx = getComponentsCtx();

	componentsCtx.each(function(index, element) {
		var componentCtx    = jQuery(element);
		var componentId     = componentCtx.data('component-id');
		var componentType   = componentCtx.data('component-type');
		var surfaceCtx      = getActiveSurfaceCtx(componentCtx);
		var surfaceCode     = surfaceCtx.data('surface-code');
		// var surfaceLabel    = jQuery('.surface-label', surfaceCtx).text().trim();
		var surfaceLabel    = surfaceCtx.data('surface-name');
		var colorCtx        = getActiveColorCtx(surfaceCtx);
		var colorCode       = colorCtx.data('color-code');
		var colorLabel      = ('' != colorCtx.attr('title')) ? colorCtx.attr('title') : colorCtx.attr('data-original-title');
		var colorPaletteCtx = getColorPaletteCtx(colorCtx);
		var techSpecsCtx    = jQuery('.tech-specs.component[data-component-id="' + componentId + '"]', ctx);

		if ( moq < parseInt(colorPaletteCtx.data('moq')) ) {
			moq = colorPaletteCtx.data('moq');
		}

		if ( colorCode.indexOf(dummy_surface_code) == -1 ) {
			techSpecsCtx.show();
		} else {
			techSpecsCtx.hide();
		}

		jQuery('.value', techSpecsCtx).text(colorLabel.replace('<br>', ' ') + ' - ' + surfaceLabel);
	});

	var refillOptionsCtx   = getRefillOptionsCtx();
	var selectedRefillCtx  = getSelectedRefillCtx(refillOptionsCtx);
	var refillId           = selectedRefillCtx.data('refill-id');
	var inkColorOptions    = getInkColorOptionsCtx(refillOptionsCtx, refillId);
	var inkColorCtx        = getActiveInkColorCtx(inkColorOptions);
	var optionId           = inkColorCtx.data('option');
	var diameterOptionsCtx = getRefillDiameterOptionsCtx(refillOptionsCtx, refillId);
	var diameterOptionCtx  = getRefillDiameterOptionCtx(optionId, '=', diameterOptionsCtx);
	var diameterCtx        = getSelectedDiameterCtx(diameterOptionCtx);
	var extraOptionsCtx    = getRefillColorOptionsCtx(refillOptionsCtx, refillId);
	var refillColorCtx     = getActiveRefillColorCtx(extraOptionsCtx);
	var refillColor        = '';

	if ( extraOptionsCtx.length > 0 ) {
		if ( jQuery('label', selectedRefillCtx.closest('.refill-radio')).text().toLowerCase().indexOf(jQuery('label', refillColorCtx).text().trim().toLowerCase()) == -1 ) {
			refillColor = ' - ' + jQuery('label', refillColorCtx).text().trim();
		}
	}

	var values = [
		jQuery('label', selectedRefillCtx.closest('.refill-radio')).html() + refillColor,
		jQuery('label', inkColorCtx).text().trim(),
		jQuery('label', diameterCtx).text().trim()
	];

	jQuery('.tech-specs.refill', ctx).each(function(index, element) {
		var subCtx = jQuery(element);

		jQuery('.value', subCtx).html(values[index]);

	});

	var productCode = getProductCode();

	jQuery('.tech-specs .moq-value', ctx).html(moq);
	jQuery('.tech-specs.model .product-code', ctx).text(productCode);
	jQuery('.selected-model .product-code').text(productCode);

	updatePrice();

	jQuery('#saved-configurations-container').fadeOut();

	if ( QRCodeEnabled ) {
		jQuery('.tech-specs .qrcode', ctx).show();
	} else {
		jQuery('.tech-specs .qrcode', ctx).hide();
	}
}



/**
 * Memorizza i dati della configurazione in un JSON.
 *
 * @param  {string} format : formato con cui restituire i dati della configurazione. Accetta "string" o "array"
 *
 * @return {string|array}
 *
 * @since 1.0.0
 */
function getConfigurationData(format) {
	var penModelId    = getModelId();
	var penModelName  = getModelFullName();
	var penModelSlug  = getModelSlug();
	var recapCtx      = jQuery('#pills-recap');
	var penModel      = jQuery('.tech-specs.model .model', recapCtx).text().trim();
	var productCode   = jQuery('.tech-specs.model .product-code', recapCtx).text().trim();

	productCode       = penModel + ' ' + productCode;

	var components    = new Array();
	var componentsCtx = getComponentsCtx();

	componentsCtx.each(function(index, element) {
		var componentCtx  = jQuery(element);
		var surfaceCtx    = getActiveSurfaceCtx(componentCtx);
		var colorCtx      = getActiveColorCtx(surfaceCtx);
        var componentItem = {
			componentLabel: componentCtx.data('component-label'),
			componentId: componentCtx.data('component-id'),
			surfaceCode: surfaceCtx.data('surface-code'),
			surfaceId: surfaceCtx.data('surface-id'),
			colorCode: colorCtx.data('asset-color-code')
		};

		components.push(componentItem);
	});

	var imprint = new Array();
	var areaIds = new Array();

	jQuery('.pen-preview.imprint .print-area[data-visible="true"]').each(function(index, element) {
		var areaCtx   = jQuery(element);
		var areaId    = areaCtx.data('area-id');
		var areaCode  = areaCtx.data('area-code');
		var areaLabel = jQuery('#v-pills-printareas-tab .nav-link[data-area-id="' + areaId + '"] a').text().trim();

		if ( jQuery.inArray( areaId, areaIds ) == -1 ) {
			if ( jQuery('.print-area-content', areaCtx).length > 0 ) {
				var span        = jQuery('.print-area-content span', areaCtx);
				var dataType    = ( span.length > 0 ) ? 'text' : 'image';
				var dataContent = '';

				if ( 'text' == dataType ) {
					var customText = ( span.hasClass('input') ) ? span.text() : span.html();
					var fontWeight = span.css('font-weight');

					if ( fontWeight == '400' || fontWeight == 'normal' ) {
						fontWeight = 'normal';
					}
					if ( fontWeight == '700' || fontWeight == 'bold' ) {
						fontWeight = 'bold';
					}

					dataContent = {
						text: customText,
						fontFamily: span.css('font-family'),
						fontSize: parseInt(span.css('font-size')),
						fontWeight: fontWeight,
						fontStyle: span.css('font-style'),
						fontColor: rgb2hex(span.css('color')), // Comprende il simbolo #.
						textAlign: span.css('text-align'),

						// Sembra che la proprietà CSS "transform" (e relative varianti: -webkit, -ms, -o, -moz) non venga letta sui dispositivi mobili.
						// Il valore restituito risulta sempre pari a 0.
						//"textRotation": getRotationDegrees(span.parent())
						textRotation: span.parent().data('text-rotation')
					};
				} else {
					var imageUrl = jQuery('.print-area-content img', areaCtx).attr('src');

					dataContent  = {
						base64: imageUrl
					};

					jQuery.each(printAreaContentInfo[areaId], function(key, value) {
						dataContent[key] = value;
					});
				}

				var topOffset   = ( areaCtx.data('movable') == true ) ? areaCtx.css('top') : '';
				var imprintItem = {
					areaLabel: areaLabel,
					areaId: areaId,
					areaCode: areaCode,
					dataType: dataType,
					dataContent: dataContent,
					topOffset: topOffset
				};

				imprint.push(imprintItem);
			}
		}
		areaIds.push(areaId);
	});

	var refillOptionsCtx   = getRefillOptionsCtx();
	var selectedRefillCtx  = getSelectedRefillCtx(refillOptionsCtx);
	var refillId           = selectedRefillCtx.data('refill-id');
	var inkColorOptions    = getInkColorOptionsCtx(refillOptionsCtx, refillId);
	var inkColorCtx        = getActiveInkColorCtx(inkColorOptions);
	var optionId           = inkColorCtx.data('option');
	var diameterOptionsCtx = getRefillDiameterOptionsCtx(refillOptionsCtx, refillId);
	var diameterOptionCtx  = getRefillDiameterOptionCtx(optionId, '=', diameterOptionsCtx);
	var diameterCtx        = getSelectedDiameterCtx(diameterOptionCtx);
	var extraOptionsCtx    = getRefillColorOptionsCtx(refillOptionsCtx, refillId);
	var refillColorCtx     = getActiveRefillColorCtx(extraOptionsCtx);
	var writingSystem      = {
		refillLabel: jQuery('label', selectedRefillCtx.closest('.refill-radio')).html(),
		refillId: refillId,
		optionId: optionId,
		colorName: inkColorCtx.data('color-name'),
		ballDiameter: jQuery('label', diameterCtx).text().trim(),
		refillColorCode: (extraOptionsCtx.length > 0) ? refillColorCtx.data('color-code') : ''
	}
	var moq                = parseInt(jQuery('.tech-specs .moq-value', jQuery('#pills-recap')).text());

	switch ( format ) {
		case 'string':
			var cfgData = {
				productCode: productCode,
				penModelName: penModelName,
				penModelId: penModelId,
				penModelSlug: penModelSlug,
				components: components,
				imprint: imprint,
				writingSystem: writingSystem,
				moq: moq,
				qrcode: QRCodeEnabled
			};

			return JSON.stringify(cfgData);
			break;
		case 'array':
			var cfgData        = [];
			var config         = {
				productCode: productCode,
				penModelName: penModelName,
				penModelId: penModelId,
				penModelSlug: penModelSlug,
				components: components,
				writingSystem: writingSystem,
				moq: moq,
				qrcode: QRCodeEnabled
			};
			var extendedConfig = {
				imprint: imprint,
			};

			cfgData.push(JSON.stringify(config));
			cfgData.push(JSON.stringify(extendedConfig));

			return cfgData;
			break;
		case 'shortObj':
			jQuery.each(components, function(index, element) {
				delete element.componentLabel;
			});

			return [
				{
					penModelId: penModelId,
					penModelSlug: penModelSlug,
					components: components,
				},
				{
					imprint: [],
				}
			];
			break;
	}
}



/**
 * Recupera i dati riassuntivi della configurazione.
 * La stringa restituita corrisponde al campo "field_pen_text".
 *
 * @return {string}
 *
 * @since 1.0.0
 */
function getHTMLConfigurationSummary() {
	var recapCtx = jQuery('#pills-recap');
	var summary  = '<ul>';

	jQuery('.tech-specs.component', recapCtx).each(function(index, element) {
		var that = jQuery(element);

		if ( that.css('display') != 'none' ) {
			summary += '<li>' + jQuery('.label', that).text().trim() + ' ' + jQuery('.value', that).text().trim() + '</li>';
		}
	});

	jQuery('.tech-specs.refill', recapCtx).each(function(index, element) {
		var that = jQuery(element);

		summary += '<li>' + jQuery('.label', that).text().trim() + ' ' + jQuery('.value', that).text().trim() + '</li>';
	});

	summary += '</ul>';

	return summary;
}



/**
 * Recupera i dati riassuntivi della configurazione da inserire nel template.
 *
 * @return {array}
 *
 * @since 1.0.0
 */
function getConfigurationSummary() {
	var recapCtx      = jQuery('#pills-recap');
	var penModel      = jQuery('.tech-specs.model .model', recapCtx).text().trim();
	var productCode   = jQuery('.tech-specs.model .product-code', recapCtx).text().trim();
	var family        = jQuery('.tech-specs.model', recapCtx).data('family-code');
	var writingSystem = jQuery('.tech-specs.model .writing-system', recapCtx).text().trim();
	var summaryString = '';
	var summary       = new Array();
	var str           = penModel.substring(family.length) + ' ' + productCode;

	summaryString += family;

	summary.push(family.length);

	summaryString += str + '\n';

	summary.push(str.length);

    summaryString += writingSystem + '\n';

	jQuery('.tech-specs.component', recapCtx).each(function(index, element) {
		var that = jQuery(element);

		if ( that.css('display') != 'none' ) {
			summaryString += jQuery('.label', that).text().trim() + ' ' + jQuery('.value', that).text().trim();

			if ( jQuery('.qrcode', that).length > 0 && jQuery('.qrcode', that).css('display') != 'none' ) {
				summaryString += jQuery('.qrcode', that).text();
			}

			summaryString += '\n';
		}
	});

	var values = [];

	jQuery('.tech-specs.refill', recapCtx).each(function(index, element) {
		var that = jQuery(element);

		values.push({
			label: jQuery('.label', that).text().trim(),
			value: jQuery('.value', that).text().trim()
		});
	});

	summaryString += values[0].label + ' ' + values[0].value + ', ';
	summaryString += values[1].value + ' ' + values[1].label.replace('colour:', '').trim().toLowerCase() + ', ';
	summaryString += values[2].value + '\n';
	summaryString += '\n';
	summaryString += jQuery('.tech-specs.moq p', recapCtx).text().trim();

	summary.push(summaryString);

	return summary;
}



/**
 * Salva la configurazione.
 *
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.0.0
 */
function saveConfiguration(successCallback, errorCallback, scope) {
	var cfgData      = getConfigurationData('array');
	var cfgName      = ( jQuery('#cfgname').val() ) ? jQuery('#cfgname').val() : Math.floor((Math.random() * 10000) + 1);
	var summary      = getHTMLConfigurationSummary();
	var imageFormat  = 'png';
	var imagesBase64 = [];

	function renderImage(res, tpl, resize, imageFormat) {
		var renderImageDeferred = jQuery.Deferred();
		var viewCode            = 'all';
		var imprint             = true;

		createPreviewTemplate(res, tpl, resize, imageFormat, imprint, viewCode, function( returnVal ) {
			imagesBase64.push(returnVal);
			renderImageDeferred.resolve();
		});

		return renderImageDeferred.promise();
	}

	jQuery.when(renderImage('hi', false, 0.5, imageFormat)).done(function() {
		jQuery.when(renderImage('hi', true, 1, imageFormat)).done(function() {
			var args = {
				cfgData: cfgData,
				cfgName: cfgName,
				summary: summary,
				imagesBase64: imagesBase64,
				format: imageFormat,
				scope: scope
			};

			if ( is_defined(Cookies.get('instance')) ) {
				var cookieValue = JSON.parse(Cookies.get('instance'));

				args.userId     = cookieValue.userId;

				_saveConfiguration(args, successCallback, errorCallback);
			} else {
				userId(
					function(userId) {
						args.userId = userId;

						_saveConfiguration(args, successCallback, errorCallback);
					},
					function(error) {
						console.log(error);
					});
			}
		}); // FINE secondo jQuery.when
	}); // FINE primo jQuery.when
}

function _saveConfiguration(args, successCallback, errorCallback) {
	var timestamp      = jQuery.now();
	var model          = getModelShortName();
	var modelId        = getModelId();
	var modelSlug      = getModelSlug();
	var productCode    = getFullProductCode().replace(/ /g, '-');
	var modelTagName   = getModelTagName();

	// Definisco i nomi dei file corrispondenti alle anteprime in bassa ed alta risoluzione nel formato:
	//    uid{user ID}_{model slug}_{product code}_{timestamp}_{resolution}.png
	//
	// es. uid24_ds3biotic_DS3-TBB_1547213847155_low.png
	var baseFilename   = 'uid' + args.userId + '_' + modelSlug + '_' + productCode + '_' + timestamp;
	var lowresFilename = baseFilename + '_low.' + args.format;
	var hiresFilename  = baseFilename + '_hi.' + args.format;
	var requestData    = {
		title: [{ value: args.cfgName }],
		type: [{ target_id: 'pen_configuration' }],
		//field_model: [{ target_id: modelTagName }],
		field_model: [{ value: getModelFullName() }],
		field_penid: [{ value: modelId }],
		field_pen_image_conf: [{ value: lowresFilename }],
		field_pen_image_conf_text: [{ value: hiresFilename }],
		field_pen_text: [{ value: args.summary }],
		field_jsonconfiguration: [{ value: args.cfgData[0] }],
		field_jsonextendedconfiguration: [{ value: args.cfgData[1] }]
	};

	if ( is_defined(Cookies.get('dealer')) ) {
		var dealer = JSON.parse(Cookies.get('dealer'));

		requestData.field_dealer_frame = [{ value: dealer.nid }];
	}

	var lowresBase64 = args.imagesBase64[0];
	var hiresBase64  = args.imagesBase64[1];

	checkConnect(
		function(loggedIn, token) {
			if ( loggedIn ) {
				if ( is_defined(Cookies.get('instance')) ) {
					var cookieValue = JSON.parse(Cookies.get('instance'));

					token = cookieValue.token;

					__saveConfiguration(requestData, lowresBase64, hiresBase64, lowresFilename, hiresFilename, args.format, token, successCallback, errorCallback);
				} else {
					userInfo(args.userId,
						function(data) {
							__saveConfiguration(requestData, lowresBase64, hiresBase64, lowresFilename, hiresFilename, args.format, token, successCallback, errorCallback);
						},
						function(error) {
							errorCallback(error);
					});

				}
			} else {
				if ( 'anonymous' == args.scope ) {
					var error = {
						status: 503,
						responseText: 'Unexpected error occurred [connect/save]',
						courtesyMessage: 'Please reload the page and try again'
					};

					displayLoading(false, null);
					errorCallback(error);
				} else {
					jQuery('#save-modal').modal('hide');
					showLoginModal();
					displayLoading(false, null);
				}
			}
		},
		function(error) {
			errorCallback(error);
		});
}

function __saveConfiguration(requestData, lowresBase64, hiresBase64, lowresFilename, hiresFilename, format, token, successCallback, errorCallback) {
	createNode(
		requestData,
		token,
		function(result) {
			var nodeId = result.nid[0].value;

			savePreviewImagesToFile(lowresBase64,
				hiresBase64,
				lowresFilename,
				hiresFilename,
				format,
				function() {
					successCallback(nodeId);
				},
				function(error) {
					errorCallback(error);
				});
		},
		function(error) {
			errorCallback(error);
		});
}



/**
 * Salva le immagini di anteprima in base64 (in alta e bassa risoluzione) in file nella cartella "saved_pens" sul server.
 *
 * @param {string}   lowresBase64    : base64 dell'anteprima in bassa risoluzione
 * @param {string}   hiresBase64     : base64 dell'anteprima in alta risoluzione
 * @param {string}   lowresFilename  : nome del file relativo all'anteprima in bassa risoluzione
 * @param {string}   hiresFilename   : nome del file relativo all'anteprima in alta risoluzione
 * @param {string}   format          : formato in cui salvare l'immagine
 * @param {function} successCallback :
 * @param {function} errorCallback   :
 *
 * @since 1.1.0
 */
function savePreviewImagesToFile(lowresBase64, hiresBase64, lowresFilename, hiresFilename, format, successCallback, errorCallback) {
	var blobLowres = base64ToBlob(lowresBase64);
	var blobHires  = base64ToBlob(hiresBase64);
	var fd         = new FormData();

	fd.append("action", 'minerva_save_preview_to_file');
	fd.append("lowresFilename", lowresFilename);
	fd.append("hiresFilename", hiresFilename);
	fd.append("format", format);
	fd.append("lowresImageFile", blobLowres);
	fd.append("hiresImageFile", blobHires);

	jQuery.ajax({
		url: minerva_common_vars.ajaxurl,
		type: "POST",
		contentType: false,
		processData: false,
		cache: false,
		dataType: "json",
		data: fd,
		success: function(result) {
			if ( result.lowres.success && result.hires.success ) {
				successCallback();
			} else {
				errorCallback(result);
			}
		},
		error: function(error)  {
			errorCallback(error);
		}
	});
}



/**
 * Crea l'immagine di anteprima della configurazione con i dati riassuntivi.
 * L'immagine finale si basa sul template fornito da Prodir.
 *
 * @param {string} res      : risoluzione delle immagini
 * @param {float}  resize   : fattore di cui riscalare l'anteprima
 * @param {bool}   tpl      : true/false per utilizzare il template
 * @param {string} viewCode : codice della vista, oppure "all"
 * @param {bool}   imprint  : true/false per considerare anche la personalizzazione delle aree di stampa
 *
 * @since 1.0.0
 */
function downloadPreviewImage(res, resize, tpl, viewCode, imprint) {
	var recapCtx            = jQuery('#pills-recap');
	var penModel            = jQuery('.tech-specs.model .model', recapCtx).text().replace('.', '_');
	var productCode         = jQuery('.tech-specs.model .product-code', recapCtx).text();
	var primaryComponentCtx = getPrimaryComponentCtx();
	var primarySurfaceCtx   = getActiveSurfaceCtx(primaryComponentCtx);
	var primaryColorCtx     = getActiveColorCtx(primarySurfaceCtx);
	var colorCode           = primaryColorCtx.data('color-code');
	var assetColorCode      = primaryColorCtx.data('asset-color-code');
	var fileName            = '';
	var imageBase64         = null;

	tpl                     = is_defined(tpl) ? tpl : true;
	viewCode                = is_defined(viewCode) ? viewCode : 'all';
	imprint                 = is_defined(imprint) ? imprint : true;

	var imageFormat         = 'png';

    if ( colorCode.indexOf('-') > -1 ) {
        colorCode = colorCode.substr(colorCode.indexOf('-') + 1);
    }

	fileName = 'Prodir_' + penModel + '_' + productCode + '_'+ colorCode;

	function renderPreview(res, tpl, resize, imageFormat, imprint, viewCode) {
		var renderPreviewDeferred = jQuery.Deferred();

		createPreviewTemplate(res, tpl, resize, imageFormat, imprint, viewCode, function(returnVal) {
			imageBase64 = returnVal;
			renderPreviewDeferred.resolve();
		});

		return renderPreviewDeferred.promise();
	}

	jQuery.when(renderPreview(res, tpl, resize, imageFormat, imprint, viewCode)).done(function() {
		var file = fileName + imageFormat;
		var str  = imageBase64.replace('data:image/' + imageFormat + ';base64,', '');

		while (str.length % 4 > 0) {
			imageBase64 += '=';
		}

		if ( imageBase64.slice(-3) == '===' ) {
			imageBase64 = imageBase64.slice(0, -1);
		}

		displayLoading(false, null);
		jQuery('#download-modal').modal('show');
		jQuery('#download-modal .modal-body img').attr('src', imageBase64).attr('alt', fileName).css('width', '100%');
	});
}



/**
 * Aggiorna l'interfaccia utente.
 *
 * @param {int|null} userId :
 *
 * @since 1.1.0
 */
function updateUI(userId) {
	if ( is_defined(userId) && userId ) {
		jQuery('.btnLogin').closest('div').hide();
		jQuery('.btnSave').closest('div').show();
		jQuery('.btnLogout').closest('div').show();
	} else {
		jQuery('.btnLogin').closest('div').show();
		jQuery('.btnSave').closest('div').hide();
		jQuery('.btnLogout').closest('div').hide();
	}
}



/**
 * Mostra la modal-popup per il login.
 *
 * @since 1.1.0
 */
function showLoginModal() {
	jQuery('#login-modal').modal('show');
}



/**
 * Mostra la modal-popup per il salvataggio della configurazione.
 *
 * @param {bool} show : "true" per aprire la modal, "false" per chiuderla
 *
 * @since 1.1.0
 */
function showSaveModal(show) {
	if ( !is_defined(show) || (is_defined(show) && show ) ) {
		jQuery('#save-modal').modal('show');
	} else {
		jQuery('#save-modal').modal('hide');
	}

}



/**
 * Inserisce il codice di tracciamento di DoubleClick.
 *
 * @since 2.1.0
 */
function doubleClick() {
	var iubCookie = Cookies.get('_iub_cs-' + minerva_common_vars.iub.cookie_policy_id[minerva_common_vars.lang]);

	if ( is_defined(iubCookie) ) {
		iubCookie = JSON.parse(iubCookie);

		if ( is_defined(iubCookie.purposes[5]) && iubCookie.purposes[5] ) {
			/**
			 * ID attività          : 6010466
			 * Nome attività        : Configuratore - Login & Save - Save Button - prodir
			 * Nome gruppo attività : Configuratore - Login & Save - Save Button
			 * Data creazione       :
			 */
			var axel    = Math.random() + "";
			var a      = axel * 10000000000000;
			var iframe = '<iframe src="https://8006742.fls.doubleclick.net/activityi;src=8006742;type=confi00;cat=confi0;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none" id="doubleclick-config-iframe"></iframe>'

			$('body').append(iframe);
		}
	}
}
